// extracted by mini-css-extract-plugin
export default {"default":"TicketSalesEndDate-rebranding-module__default___2FLa0"};